import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
export interface ColumnSmallTable {
  title: string;
  name?: string;
  className?: string;
  renderValue?: (item?: any) => any;
}
@Component({
  standalone: false,
  selector: 'app-modal-small-table',
  templateUrl: './modal-small-table.component.html',
  styleUrls: ['./modal-small-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalSmallTableComponent implements OnInit {
  displayedColumns: string[];
  @Input() COLUMNS: ColumnSmallTable[];
  @Input() DATA: any[];
  constructor() { }

  ngOnInit() {
    this.displayedColumns = this.COLUMNS.map(x => x.name);
  }

}
